import * as t from 'io-ts';
import { Email, UUID } from '@thingos/io-ts-shared';
export const LoginData = t.type({
    email: Email,
    password: t.string,
    remember: t.boolean,
});
export const UserCreationData = t.type({
    email: Email,
    password: t.string,
});
export const UserInvitationData = t.type({
    email: t.string,
});
export const UserInfo = t.intersection([
    t.type({
        id: UUID,
        email: Email,
        isAdmin: t.boolean,
        invitePending: t.boolean,
    }),
    t.partial({
        name: t.string,
    }),
]);
//# sourceMappingURL=user.js.map